import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FieldErrorAndDescription, FieldErrorAndDescriptionProps } from 'shared/components/form/field-error-and-description';
import { FieldLabel, FieldLabelProps } from 'shared/components/form/field-label';
type DeadlineSettingsRadioGroupProps<T extends number> = FieldLabelProps & FieldErrorAndDescriptionProps & {
  options: DeadlineSettingsRadioGroupDataInterface<T>[];
  selected: T[];
  className?: string;
  disabled?: boolean;
  onChange: (value: T) => void;
};
export interface DeadlineSettingsRadioGroupDataInterface<T> {
  id: T;
  caption: string;
}
const DeadlineSettingsRadioGroup = t0 => {
  const $ = _c(21);
  const {
    options,
    selected,
    onChange,
    disabled,
    error,
    label,
    required,
    labelClassName
  } = t0;
  let t1;
  if ($[0] !== label || $[1] !== labelClassName || $[2] !== required) {
    t1 = <FieldLabel label={label} labelClassName={labelClassName} required={required} />;
    $[0] = label;
    $[1] = labelClassName;
    $[2] = required;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== disabled || $[5] !== onChange || $[6] !== options || $[7] !== selected) {
    let t3;
    if ($[9] !== disabled || $[10] !== onChange || $[11] !== selected) {
      t3 = option => <li key={option.id}><label className={`r relative flex items-center gap-2 ${!disabled && "cursor-pointer"} w-fit `}><input className={`border-2 outline-hidden ${disabled ? "border-fill-primary/70" : "border-fill-primary"} h-[20px] w-[20px] rounded-full ${selected.includes(option.id) ? "bg-background-secondary" : "bg-transparent"} main-transition-colors ring-brand-primary appearance-none ring-offset-1 focus-visible:ring-2`} disabled={disabled} checked={selected.includes(option.id)} value={option.caption} onClick={() => onChange(option.id)} onChange={_temp} type="radio" /><svg width={20} height={20} className={`main-transition-colors absolute ${selected.includes(option.id) ? "fill-green" : "fill-transparent"} ${disabled && "opacity-70"}`}><path fillRule="evenodd" clipRule="evenodd" d="M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z" /></svg><span className={`main-transition-colors ${selected.includes(option.id) ? "text-text-primary" : "text-text-primary/50"} ${disabled && "opacity-70"}`}>{option.caption}</span></label></li>;
      $[9] = disabled;
      $[10] = onChange;
      $[11] = selected;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t2 = options.map(t3);
    $[4] = disabled;
    $[5] = onChange;
    $[6] = options;
    $[7] = selected;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[13] !== t2) {
    t3 = <ul className="flex flex-wrap items-center gap-5">{t2}</ul>;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== error) {
    t4 = <FieldErrorAndDescription error={error} />;
    $[15] = error;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t1 || $[18] !== t3 || $[19] !== t4) {
    t5 = <div className="flex flex-col gap-1">{t1}{t3}{t4}</div>;
    $[17] = t1;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};
export default DeadlineSettingsRadioGroup;
function _temp() {}